import React, { useState } from 'react'
import { TextField } from '@mui/material'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { DesktopDatePicker } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'

const DemoDatePicker = (props: DatePickerProps) => {
  const { label, disabled } = props
  const [startDate, setStartDate] = useState<Date | null>()

  const handleStartDate = (newValue: Date | null) => {
    setStartDate(newValue)
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DesktopDatePicker
        label={label}
        inputFormat='dd/MM/yyyy'
        value={startDate}
        onChange={handleStartDate}
        renderInput={(params) => (
          <TextField placeholder='Start Date' variant='standard' {...params} />
        )}
        disabled={disabled}
      />
    </LocalizationProvider>
  )
}

export default DemoDatePicker

interface DatePickerProps {
  label: string
  disabled: boolean
}
